export const techStack = [

  { name: "AWS", link: "https://img.icons8.com/?size=100&id=33039&format=png&color=000000" },
  { name: "Azure", link: "https://img.icons8.com/?size=100&id=VLKafOkk3sBX&format=png&color=000000" },
  { name: "Python", link: "https://img.icons8.com/?size=100&id=13441&format=png&color=000000" },
  { name: "Linux", link: "https://img.icons8.com/?size=100&id=WbRVMGxHh74X&format=png&color=000000" },
  { name: "Postman", link: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg" },

  { name: "Jenkins", link: "https://img.icons8.com/?size=100&id=39292&format=png&color=000000" },
  { name: "Azure DevOps", link: "https://img.icons8.com/?size=100&id=81727&format=png&color=000000" },
  { name: "GitHub Actions", link: "https://github.gallerycdn.vsassets.io/extensions/github/vscode-github-actions/0.27.0/1727202375538/Microsoft.VisualStudio.Services.Icons.Default" },
  { name: "Terraform", link: "https://img.icons8.com/?size=100&id=kEkT1u7zTDk5&format=png&color=000000" },
  { name: "Ansible", link: "https://img.icons8.com/?size=100&id=iGCCE2iEmh2u&format=png&color=000000" },
  
  { name: "GitHub", link: "https://img.icons8.com/?size=40&id=62856&format=png&color=000000" },
  { name: "Git", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-plain.svg" },
  { name: "Docker", link: "https://img.icons8.com/?size=100&id=cdYUlRaag9G9&format=png&color=000000" },
  { name: "Kubernetes", link: "https://img.icons8.com/?size=100&id=cvzmaEA4kC0o&format=png&color=000000" },
  { name: "Prometheus", link: "https://img.icons8.com/?size=100&id=NrcKwdmlOBfE&format=png&color=000000" },
  
  { name: "Grafana", link: "https://img.icons8.com/?size=100&id=9uVrNMu3Zx1K&format=png&color=000000" },
  { name: "RedHat Linux", link: "https://img.icons8.com/?size=100&id=h2fWCnoQXWPf&format=png&color=EE0000" },
  { name: "SQL", link: "https://cdn-icons-png.flaticon.com/512/4299/4299956.png"},
  { name: "Mongo DB", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-plain.svg" },
  { name: "Nginx", link: "https://img.icons8.com/?size=100&id=t2x6DtCn5Zzx&format=png&color=000000" },
  
  // { name: "Bash", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bash/bash-original.svg" },
  // { name: "ArgoCD", link: "https://argo-cd.readthedocs.io/en/stable/assets/logo.png" },
  // { name: "Team City", link: "https://www.incredibuild.com/wp-content/uploads/2021/03/TeamCity01-1-150x150.png" },
  // { name: "Octopus", link: "https://a.storyblok.com/f/92909/x/084296103a/logo-blue_140px_rgb.svg" },
  // { name: "AWS Cloud Formation", link: "https://iconduck.com/api/v2/vectors/vctrhqcl6d1x/media/png/512/download" },
  // { name: "DataDog", link: "https://static-00.iconduck.com/assets.00/datadog-icon-957x1024-ksuqw1rf.png" }
  ]


export const contactLinks = [{ name: 'LinkedIn', url: 'https://img.icons8.com/?size=40&id=13930&format=png&color=000000', darkUrl: 'https://img.icons8.com/?size=40&id=13930&format=png&color=000000', link: 'https://www.linkedin.com/in/adilansari488/'}, 
  { name: 'Dev.To', url: 'https://img.icons8.com/?size=40&id=n98knU41v5Aq&format=png&color=000000', darkUrl: 'https://img.icons8.com/?size=40&id=n98knU41v5Aq&format=png&color=000000', link: 'https://dev.to/adilansari' },
  { name: 'Github', url: 'https://img.icons8.com/?size=40&id=62856&format=png&color=000000', darkUrl: 'https://img.icons8.com/?size=100&id=AZOZNnY73haj&format=png&color=000000', link :'https://github.com/adilansari488'}
]



export const articleData = [
  {
    name: 'Secure AWS API Gateway with IAM',
    desc: 'If you\'re using AWS API Gateway and want to secure it with IAM credentials from your AWS users, you\'re at the right place. AWS offers several methods to secure REST APIs, including API keys, Lambda authorizers, and Amazon Cognito...',
    img: "https://media2.dev.to/dynamic/image/width=1000,height=420,fit=cover,gravity=auto,format=auto/https%3A%2F%2Fdev-to-uploads.s3.amazonaws.com%2Fuploads%2Farticles%2Fu061k32qu9dykyb0q157.png",
    articleLink: "https://dev.to/aws-builders/secure-aws-api-gateway-with-iam-3n29"
  },
  {
    name: 'URL Redirection Using API Gateway',
    desc: 'API gateway is a popular choice of many developers and cloud engineers for multiple use cases. However redirecting to a new URL using API Gateway can be challenging unless you give proper response headers to it...',
    img: "https://media2.dev.to/dynamic/image/width=1000,height=420,fit=cover,gravity=auto,format=auto/https%3A%2F%2Fdev-to-uploads.s3.amazonaws.com%2Fuploads%2Farticles%2F0clnxrtzt5nbeiw2pc61.png",
    articleLink: "https://dev.to/aws-builders/url-redirection-using-api-gateway-5b93"
  },

  {
    name: 'Fetch AWS Secrets in Your Kubernetes Realm',
    desc: 'It is very crucial to store our credentials securely. And this article will guide you how you can leverage the scaling of aws cloud and power of kubernetes to store and use securely your credentials in your apps deployed on kubernetes environment...',
    img: "https://media2.dev.to/dynamic/image/width=1000,height=420,fit=cover,gravity=auto,format=auto/https%3A%2F%2Fdev-to-uploads.s3.amazonaws.com%2Fuploads%2Farticles%2Frhyzpmru0s9sa0fy2tew.png",
    articleLink: "https://dev.to/aws-builders/fetch-aws-secrets-in-your-kubernetes-realm-np3"
  },


]

export const API_KEY = "p49CBNa0ej7Grx5UYdGu97dJTVGmVljTt7g8l5Eh"